module.exports = __webpack_public_path__ + "07adfe2446c4665dd420f420c37748ce.MP3";